document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('small-description');
  if (!trigger) return;

  const accordion = document.querySelector('.product__accordion');
  if (!accordion) return;

  trigger.addEventListener('click', () => {
    accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });

    accordion.querySelectorAll('summary').forEach(s => s.setAttribute('aria-expanded', 'true'));
    accordion.querySelectorAll('details').forEach(d => d.setAttribute('open', 'true'));
  });
});
